module.exports = __webpack_public_path__ + "img/txt.8080b0d9.svg";